import { render, staticRenderFns } from "./DettaglioAziendaTabellaQuestionari.vue?vue&type=template&id=4c34b34e&scoped=true&"
import script from "./DettaglioAziendaTabellaQuestionari.vue?vue&type=script&lang=js&"
export * from "./DettaglioAziendaTabellaQuestionari.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioAziendaTabellaQuestionari.vue?vue&type=style&index=0&id=4c34b34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c34b34e",
  null
  
)

export default component.exports